import { Button } from "../../../../components/ui/common/button";
import { FacilityListPaginationProps } from "../types/facilityList.types";

/** Footer: result range on the left, Previous / Page X / Y / Next on the right. */
export const FacilityListPagination = ({
  rangeStart,
  rangeEnd,
  totalCount,
  pageNumber,
  totalPages,
  onPageChange
}: FacilityListPaginationProps) => (
  <div className="tw-mt-3 tw-flex tw-items-center tw-justify-between">
    <p className="tw-text-xs tw-text-muted-foreground">
      {rangeStart}–{rangeEnd} of {totalCount} facilities
    </p>
    {totalPages > 1 ? (
      <div className="tw-flex tw-items-center tw-gap-2">
        <Button
          variant="outline"
          size="sm"
          disabled={pageNumber <= 1}
          onClick={() => onPageChange(pageNumber - 1)}
        >
          Previous
        </Button>
        <span className="tw-text-sm tw-text-muted-foreground">
          Page {pageNumber} / {totalPages}
        </span>
        <Button
          variant="outline"
          size="sm"
          disabled={pageNumber >= totalPages}
          onClick={() => onPageChange(pageNumber + 1)}
        >
          Next
        </Button>
      </div>
    ) : null}
  </div>
);
